const createErrorResponse = async (response) => {
  // eslint-disable-next-line unicorn/error-message
  const error = new Error();

  error.status = response.status;

  let responseJSON = null;

  try {
    responseJSON = await response.json();

    error.message = JSON.stringify(responseJSON);
  } catch (e) {
    error.message = '';
  }

  if (typeof responseJSON?.error === 'string') {
    try {
      error.json = {
        error: JSON.parse(
          // Trim any text from the beginning of the JSON such as "(RECIPIENT_FAILURE,401)"
          responseJSON.error.replace(/^[^[{]*/, '')
        ),
      };
    } catch (e) {
      error.json = null;
    }
  }

  if (!error.json) {
    error.json = responseJSON;
  }

  return error;
};

export default createErrorResponse;
